import React, { useContext, useState } from "react";
import { TransactionContext } from "./transactionContext";


function Child() {
    let { transactions, addTransaction } = useContext(TransactionContext)
    let [newDesc, setDesc] = useState("");
    let [newAmount, setAmount] = useState(0);

    
    const handleAddition = (event) => {
        event.preventDefault()
        if (Number(newAmount) === 0) {
            alert("Amount can not be zeroo")
            return false
        }
        else if (newDesc === "") {
            alert("please enter any description")
            return false
        }
        addTransaction({
            amount: Number(newAmount),
            desc: newDesc
        })
        setDesc('')
        setAmount(0)
    }

    const getIncome = () => {
        let income = 0;
        for (var i = 0; i < transactions.length; i++) {
            if (transactions[i].amount > 0)
                income += transactions[i].amount
        }
        return income;
    }

    const getExpense = () => {
        let expense = 0;
        for (var i = 0; i < transactions.length; i++) {
            if (transactions[i].amount < 0)
                expense += transactions[i].amount
        }
        return expense;
    }
    return (
        <div className="container">
            <h1>Expense Tracker App</h1>
            <h2>Your Balance: ${getIncome() + getExpense()}</h2>

            <div className="expense-container">
                <h3 className="income">INCOME<br />${getIncome()}</h3>
                <h3 className="expense">EXPENSE<br />${getExpense()}</h3>
            </div>
            <h3>History</h3>
            <hr />
            <ul className="transaction-list">
                {transactions.map((transObj, ind) => {
                    return (
                        <li key={ind}>
                            <span>{transObj.desc}</span>
                            <span>${transObj.amount}</span>
                        </li>)
                })}
            </ul>
            <h3>Add New Transaction</h3>
            <hr />
            <form className="transaction-form">
                <label>Enter Description</label><br />
                <input value={newDesc} placeholder="Enter Text" type="text" onChange={(ev) => setDesc(ev.target.value)} required></input><br />

                <label>Enter Amount</label><br />
                <input value={newAmount} placeholder="Enter Amount" type="Number" onChange={(ev) => setAmount(ev.target.value)} required></input><br /><br />
                <button onClick={handleAddition}>Add Transaction</button>
            </form>

            <br /><br /><br />
            <div>Expense Tracker App By Ahmed Anis</div>
        </div>
    );
}

export default Child;